/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M15 2L15 22"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M2 8.4C2 6.15979 2 5.03969 2.43597 4.18404C2.81947 3.43139 3.43139 2.81947 4.18404 2.43597C5.03969 2 6.15979 2 8.4 2H15V22H8.4C6.15979 22 5.03969 22 4.18404 21.564C3.43139 21.1805 2.81947 20.5686 2.43597 19.816C2 18.9603 2 17.8402 2 15.6V8.4Z"
				fill="currentColor"
			/>
			<path
				d="M15 2L15 22M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M13.25 2.85C13.25 2.28995 13.25 2.00992 13.141 1.79601C13.0451 1.60785 12.8922 1.45487 12.704 1.35899C12.4901 1.25 12.2101 1.25 11.65 1.25H9.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H11.65C12.2101 22.75 12.4901 22.75 12.704 22.641C12.8922 22.5451 13.0451 22.3922 13.141 22.204C13.25 21.9901 13.25 21.7101 13.25 21.15L13.25 2.85ZM14.75 21.4167C14.75 21.7267 14.75 21.8817 14.7841 22.0088C14.8765 22.3539 15.1461 22.6235 15.4912 22.7159C15.6183 22.75 15.7733 22.75 16.0833 22.75C17.6333 22.75 18.4083 22.75 19.0441 22.5796C20.7696 22.1173 22.1173 20.7696 22.5796 19.0441C22.75 18.4083 22.75 17.6333 22.75 16.0833V7.91667C22.75 6.36671 22.75 5.59174 22.5796 4.9559C22.1173 3.23044 20.7696 1.88271 19.0441 1.42037C18.4083 1.25 17.6333 1.25 16.0833 1.25C15.7733 1.25 15.6183 1.25 15.4912 1.28407C15.1461 1.37654 14.8765 1.64609 14.7841 1.99118C14.75 2.11835 14.75 2.27334 14.75 2.58333L14.75 21.4167Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M15 18V2.00111C15.7831 2.0039 16.4383 2.01368 17 2.04797C17.9805 2.10784 18.6762 2.24243 19.27 2.54497C20.2108 3.02433 20.9757 3.78924 21.455 4.73005C22 5.79961 22 7.19974 22 10V14C22 16.8003 22 18.2004 21.455 19.27C20.9757 20.2108 20.2108 20.9757 19.27 21.455C18.2004 22 16.8003 22 14 22H10C7.19974 22 5.79961 22 4.73005 21.455C3.78924 20.9757 3.02433 20.2108 2.54497 19.27C2 18.2004 2 16.8003 2 14V10C2 7.19974 2 5.79961 2.54497 4.73005C3.02433 3.78924 3.78924 3.02433 4.73005 2.54497C5.79961 2 7.19974 2 10 2H11.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M15 2L15 22M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M11.65 1.25H9.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H11.65C12.2101 22.75 12.4901 22.75 12.704 22.641C12.8922 22.5451 13.0451 22.3922 13.141 22.204C13.25 21.9901 13.25 21.7101 13.25 21.15L13.25 2.85C13.25 2.28995 13.25 2.00992 13.141 1.79601C13.0451 1.60785 12.8922 1.45487 12.704 1.35899C12.4901 1.25 12.2101 1.25 11.65 1.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14.75 21.4167C14.75 21.7267 14.75 21.8817 14.7841 22.0088C14.8765 22.3539 15.1461 22.6235 15.4912 22.7159C15.6183 22.75 15.7733 22.75 16.0833 22.75C17.6333 22.75 18.4083 22.75 19.0441 22.5796C20.7696 22.1173 22.1173 20.7696 22.5796 19.0441C22.75 18.4083 22.75 17.6333 22.75 16.0833V7.91667C22.75 6.36671 22.75 5.59174 22.5796 4.9559C22.1173 3.23044 20.7696 1.88271 19.0441 1.42037C18.4083 1.25 17.6333 1.25 16.0833 1.25C15.7733 1.25 15.6183 1.25 15.4912 1.28407C15.1461 1.37654 14.8765 1.64609 14.7841 1.99118C14.75 2.11835 14.75 2.27334 14.75 2.58333L14.75 21.4167Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
